import { ReactRouterLinkProvider } from '@elevationscu/ui-component-lib';
import i18n from 'i18next';
import axios from 'axios';
import { I18nextProvider, initReactI18next } from 'react-i18next';
import {
  // createBrowserRouter,
  createHashRouter,
  RouterProvider,
} from 'react-router-dom';

import NewUser, {
  NewUserRouteNoLoanOfficer,
  NewUserRouteWithLoanOfficer,
} from './pages/New';
import {
  ExistingUserRoute,
} from './pages/Existing';
import Test from './pages/Test';
import { ClientErrorProvider, notifyClientError } from './ClientErrorContext';

import './App.css';
import TestPmiCalculator from './pages/TestPmiCalculator';

axios.interceptors.response.use(
  (response) => {
    // Successful response
    notifyClientError(false);
    return response;
  },
  (error) => {
    if (!error.response || error.response.status >= 500) {
      notifyClientError(true);
    }
    return Promise.reject(error);
  },
);

const options = {
  debug: process.env.NODE_ENV === 'development',

  // Language to use (overrides detected language)
  lng: 'en-US',
  // Fallback Language that will be used if translations in selected lng are not available
  fallbackLng: 'en-US',
  // Ignore the country code when looking up the locale file
  load: 'languageOnly',

  // Array of namespaces to load
  ns: [],
  // Default namespace used if not passed to translation function
  defaultNS: 'common',

  // Array of allowed, non-explicit languages w/o country codes
  whitelist: ['en', 'es'],
  nonExplicitWhitelist: true,

  // Whether to load locales asynchronously immediately after calling init routine
  // https://www.i18next.com/overview/configuration-options#initimmediate
  initImmediate: false,

  // Whether to save missing keys through the backend
  saveMissing: false,

  interpolation: {
    // not needed for react as it escapes by default
    escapeValue: false,
  },
};

// Initialize React integration
i18n.use(initReactI18next);

// init i18next
// for all options read: https://www.i18next.com/overview/configuration-options
if (!i18n.isInitialized) {
  i18n.init(options);
}

const router = createHashRouter([
  NewUserRouteNoLoanOfficer,
  NewUserRouteWithLoanOfficer,
  ExistingUserRoute,
  {
    // the public url needs to be included because that is the subdirectory for where this app is served.  If left out then it will try to go to the root, which is incorrect.
    // If you use the basename property, then the # (hash) will be put before the basename, which will not serve the correct subdirectory for this app.
    path: '/test',
    element: <Test />,
    errorElement: <NewUser error />,
  },
  {
    // the public url needs to be included because that is the subdirectory for where this app is served.  If left out then it will try to go to the root, which is incorrect.
    // If you use the basename property, then the # (hash) will be put before the basename, which will not serve the correct subdirectory for this app.
    path: '/testPmiCalculator',
    element: <TestPmiCalculator />,
    errorElement: <NewUser error />,
  },
], {
  // basename: process.env.REACT_APP_PUBLIC_URL,
});

function AppWithRouterAccess() {
  return (
    <I18nextProvider>
      <ReactRouterLinkProvider>
        <ClientErrorProvider>
          <RouterProvider router={router} />
        </ClientErrorProvider>
      </ReactRouterLinkProvider>
    </I18nextProvider>
  );
}

export default AppWithRouterAccess;
